import { Circle } from '@cashew/assets';
import type { product as productType } from '@cashew/types';
import sn from 'classnames';
import React from 'react';
import { BRAND_COLORS } from '../../config/brand';

const { dateFormat } = require('@cashew/utils');

const validArray: any = [];
[3, 6, 9, 12].forEach((item) => {
  for (let i = 1; i <= item; i += 1) {
    validArray.push(`${item}${i}`);
  }
});
export default ({ ns, product, orderDetails, t }: any) => {
  const CircleEmpty = Circle('0');

  const isOrderRefunded =
    product.subProducts[0].installments.filter(
      (item: any) => item.status === 'REFUNDED'
    ).length > 0;

  return (
    <ul className={`${ns}__list-payments`}>
      {product.type === 'DELAY' && (
        <li className="order-details--paid">
          <p>
            <CircleEmpty className={`${ns}__circle`} color="#DADADA" />
            <span className={`${ns}__label-bold`}>Purchase</span>
            <br />
            <span className={`${ns}__paid-date`}>
              {`Purchased on ${dateFormat({
                date: orderDetails.purchaseDate,
              })}`}
            </span>
          </p>
        </li>
      )}
      {product.subProducts[0].installments.map(
        (
          {
            chargeDate,
            installmentAmount,
            latePaymentAmount,
            latePaymentAmountVat,
            status,
            id,
            installmentSnooze,
            installmentPurchaseFee,
          }:
            | ({
                installmentSnooze: {
                  id: number;
                  status: string;
                  amount: number;
                  amountVat: number;
                  installmentPurchaseFee: any;
                };
              } & productType.InstallmentType)
            | any,
          index: number
        ) => {
          const { length } = product.subProducts[0].installments;
          const isPaid = status === 'PAID';
          const isCancelled = status === 'CANCELLED';
          const isRefunded = status === 'REFUNDED'; // after full refund status

          const isInstallmentPending =
            product.subProducts[0].installments[index].status !== 'PAID' &&
            !isRefunded;

          const CircleRender =
            !validArray.includes(`${length}${index + 1}`) ||
            length === index + 1
              ? Circle(null)
              : Circle(`${length}${index + 1}`);

          const lateFee = Number(
            (latePaymentAmount + latePaymentAmountVat).toFixed(2)
          );
          const snoozeFee = Number(
            (
              (installmentSnooze?.amount ?? 0) +
              (installmentSnooze?.amountVat ?? 0)
            ).toFixed(2)
          );
          const totalAmount = Number(
            (
              (installmentAmount ?? 0) +
              (lateFee ?? 0) +
              (installmentPurchaseFee?.purchaseFee ?? 0) +
              (installmentPurchaseFee?.purchaseFeeVat ?? 0) +
              (isInstallmentPending ? 0 : (snoozeFee ?? 0))
            ).toFixed(2)
          );

          return (
            <li
              key={`installment-${id}`}
              className={sn({
                'order-details--paid': isPaid || isCancelled || isOrderRefunded,
              })}
            >
              <p>
                <CircleRender
                  className={`${ns}__circle`}
                  color={
                    isPaid || isCancelled || isOrderRefunded
                      ? BRAND_COLORS.primary
                      : '#dadada'
                  }
                />
                <span style={{ fontWeight: 700 }}>
                  Payment {`${index + 1}/${length}`}
                </span>
                <br />
                <span>
                  <span>
                    {orderDetails.currencyCode} {totalAmount}{' '}
                    {installmentPurchaseFee &&
                      installmentPurchaseFee?.purchaseFee +
                        installmentPurchaseFee?.purchaseFeeVat !==
                        0 && (
                        <span
                          style={{
                            color: '#8b8b8b',
                          }}
                          className="px-1"
                        >
                          {installmentPurchaseFee &&
                            installmentPurchaseFee?.purchaseFee +
                              installmentPurchaseFee?.purchaseFeeVat !==
                              0 &&
                            `(including ${installmentPurchaseFee?.purchaseFee + installmentPurchaseFee?.purchaseFeeVat} purchase fee)`}
                        </span>
                      )}
                    {!isPaid
                      ? 'due on '
                      : t('orderDetails.paidOn')?.toLowerCase()}
                  </span>
                  {dateFormat({
                    date: chargeDate,
                  })}
                </span>
                <br />
                {(!!snoozeFee || !!lateFee) && (
                  <span style={{ color: '#818181' }}>
                    {!!lateFee && ( // Late fee
                      <>
                        includes late fee ({orderDetails.currencyCode} {lateFee}
                        )
                      </>
                    )}

                    {!!snoozeFee &&
                      !!lateFee && ( // Separator (, + or none)
                        <>{isInstallmentPending ? <>,</> : <> +</>}</>
                      )}

                    {!!snoozeFee && ( // Snooze fee
                      <>
                        {isInstallmentPending || lateFee ? '' : 'includes'}{' '}
                        snooze fee ({orderDetails.currencyCode} {snoozeFee})
                        {isInstallmentPending ? ' paid' : ''}
                      </>
                    )}
                  </span>
                )}
              </p>
            </li>
          );
        }
      )}
    </ul>
  );
};
